/**
 * useFeatureGate — named Pro-only feature flags derived from useUserPlan().isPro.
 *
 * Centralizes which features are Pro-gated so components use a single named
 * flag (e.g. canUseYnab) instead of scattering raw isPro checks.
 */
import { useUserPlan } from "@/hooks/useUserPlan";

export interface FeatureGate {
  isLoading: boolean;
  canUseRenewalAlerts: boolean;
  canUseYnab: boolean;
  canExportData: boolean;
  canViewFullPaymentHistory: boolean;
  canConvertCurrency: boolean;
}

export function useFeatureGate(): FeatureGate {
  const { isPro, isLoading } = useUserPlan();

  return {
    isLoading,
    canUseRenewalAlerts: isPro,
    canUseYnab: isPro,
    canExportData: isPro,
    canViewFullPaymentHistory: isPro,
    canConvertCurrency: isPro,
  };
}
